import { Injectable } from '@angular/core';
import { ListService } from '@commoncore/services/list.service';
import { UniversalService } from '@commoncore/services/universal.service';
import { ENV_CONSTANTS } from '@env-properties/environment';

@Injectable({
  providedIn: 'root'
})
export class RedirectionService {
  constructor(public universalService:UniversalService,public listService:ListService) {
    
   }

   goToProfile(){
    if(!this.universalService.inAppWebViewOpened){
      window.location.href = '/userprofile';
    }else{
      this.listService.informAndroidAndIOSToCloseWebView("PROFILE");
    }
    this.removePromoRouteFromLocalStorage();
  }

  closePromotionsScreen(){
    // if(!this.universalService.inAppWebViewOpened){
      var url = "/home";
      window.open(url,"_self", "noopener, noreferrer");
    // }else{
    //   this.listService.informAndroidAndIOSToCloseWebView("CLOSE_VIEW");
    // }

    this.removePromoRouteFromLocalStorage();
  }

  goToHomeTab(){
    if(!this.universalService.inAppWebViewOpened){
      window.location.href = "/home";
    }else{
      this.listService.informAndroidAndIOSToCloseWebView("MY FILES");
    }

    this.removePromoRouteFromLocalStorage();
  }

  removePromoRouteFromLocalStorage(){
    localStorage.removeItem("requestedUrl");
  }

  setRequestedUrlInLocalStorageWithExpiry(key,value){
    var currentTime = new Date().getTime();
    const item = {
      value: value,
      expiry: currentTime + (ENV_CONSTANTS["constants"]["localStorageKeysExpiryTime"]*60000),
    }
    localStorage.setItem(key, JSON.stringify(item))
  }


  getRequestedUrlFromLocalStorageWithExpiry(key) {
    const itemStr = localStorage.getItem(key)
    if (!itemStr) {
      return ""
    }
    const item = JSON.parse(itemStr)
    const now = new Date().getTime();
    if (now > item.expiry) {
      this.universalService.isRequestedUrlExpired = true;
      localStorage.removeItem(key)
      return ""
    }
    return item.value
  }


  removeRequestedUrlFromLocalStorage(){
    localStorage.removeItem("requestedUrl");
  }

}
